import { useQuery } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../AuthenticatedApiRequest";
import TchrURL from "../TchrURL";

export interface PriceData {
  unitPrice: number;
  discountPrice: number;
  currency: string;
}

export interface PricingResponse {
  monthly: PriceData[];
  yearly: PriceData[];
  discount: {
    code: string;
    name: string;
    percent: number;
    repeats: string; // "repeating for repeats", anything else is a one-time discount
    duration: number; // in months
  };
}

interface UsePricingOptions {
  coupon?: string;
}

const usePricing = (options?: UsePricingOptions) => {
  const { get } = useAuthenticatedApiRequest();
  const coupon = options?.coupon;

  return useQuery<PricingResponse, Error>({
    queryKey: ["pricing", coupon],
    queryFn: async () => {
      const url = new TchrURL("payment/price");
      if (coupon) {
        url.searchParams.set("coupon", coupon);
      }
      const response = await get(url);
      return response.json();
    },
    staleTime: 1000 * 60 * 15, // Cache for 15 minutes
  });
};

export default usePricing;
